import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import classNames from "classnames";
import "./index.scss";

import { ADMIN_ORDER_REFUND, ADMIN_ORDER_REFUND_BULK } from '../../../store/reducers/order/order-actions';
import { getInitModel } from "../../../services/initModels";
import { createAction } from "../../../utils/sagaHelper";
import {
    getReshipmentTypes,
    MODEL_TYPE,
    getRefoundChannelType,
    REFOUND_CHANNEL_TYPE, getRefoundBonusChannelType, getRefoundTerminalChannelType,
} from '../../../utils/enums';

import LayoutHeaderControls from "../LayoutHeaderControls";
import OnOffSwitch from "../OnOffSwitch";
import Dropdown from "../Dropdown";
import {currentUserIsDepotRole} from "../../../services/userModel.js";

const RefundOrder = ({ t, id, maxAmount, updateItem, customerId, onClose, refundOrder, paymentId, bonusRefund, cardTerminalRefund, balkRefund, refundBulkOrder }) => {
    const minAmount = 0.01;
    const [refundType, setRefundType] = useState(getReshipmentTypes(currentUserIsDepotRole())[0]);
    const [refundChannel, setRefundChannel] = useState(
      bonusRefund
        ? getRefoundBonusChannelType()[0]
        : !customerId
        ? getRefoundTerminalChannelType()[0]
        : getRefoundChannelType()[0]
    );

    const [data, setData] = useState(getInitModel(MODEL_TYPE.refundModel, { id, paymentId }));
    const handleOnSave = () => {
        return new Promise((resolve, reject)=> {
            const request = balkRefund ? refundBulkOrder : refundOrder;
            const body = {...data, refund_channel: refundChannel.key, refund_type: refundType.key}
            request(body).then((response)=> {
                if(updateItem) updateItem(response);
                resolve();
                onClose();
            }, error=> {
                reject(error);
                toast(error);
            });
        });
    }

    const handleOnChange = (prop, value) => {
        setData({ ...data, [prop]: value });
    }

    const handleOnAmountChange = e => {
        const num = e.target.value;
        handleOnChange("amount", Number(parseFloat(num).toFixed(2)));
    }

    const isDisabled = () => {
        if(cardTerminalRefund) {
            return !(minAmount <= parseFloat(data.amount) && refundChannel.key === REFOUND_CHANNEL_TYPE.loyalty);
        }
        if(refundChannel.key === REFOUND_CHANNEL_TYPE.creditCard){
            return !(minAmount <= parseFloat(data.amount) && parseFloat(data.amount) <= parseFloat(maxAmount));
        } else {
            return false;
        }
    }

    const handleOnSelectRefundType = val => {
        setRefundType(val);
        setData({ ...data, refund_type: val.key });
    }

    const handleOnSelectRefundChannel = val => {
        setRefundChannel(val);
        setData({...data, refund_channel: val.key, partial: val === REFOUND_CHANNEL_TYPE.loyalty ? false : data.partial });
    }

    return (
        <div className={classNames("refundOrder")}>
            <div className={classNames("formControls")}>
                <div className={classNames("formControl")}>
                    <div className={classNames("title")}>{t("admin-orders.REFUND_TYPE_REASON")}</div>
                    <Dropdown value={(refundType && refundType.value) || ""} 
                        values={getReshipmentTypes(currentUserIsDepotRole())}
                        onSelect={handleOnSelectRefundType}
                    />
                </div>
                <div className={classNames("formControl")}>
                    <div className={classNames("title")}>{t("admin-orders.RESTAURANT_REFOUND_CHANNEL")}</div>
                    <Dropdown value={(refundChannel && refundChannel.value) || ""}
                              values={bonusRefund
                                  ? getRefoundBonusChannelType()
                                  : !customerId
                                      ? getRefoundTerminalChannelType()
                                      : getRefoundChannelType()
                              }
                              onSelect={handleOnSelectRefundChannel}
                    />
                </div>
                {refundChannel && refundChannel.key === REFOUND_CHANNEL_TYPE.creditCard && (
                    <div className={classNames("formControl")}>
                        <div className={classNames("title")}>{t("admin-orders.REFUND_ORDER_PARTIAL_LABEL")}</div>
                        <OnOffSwitch id={id + "partial"}
                            value={data.partial}
                            isBlueColor={true}
                            title={{
                                on: t("settings.settings.numericalSettings.YES"),
                                off: t("settings.settings.numericalSettings.NO")
                            }}
                            handleOnClick={() => handleOnChange("partial", !data.partial)}
                        />
                    </div>
                )}
                {refundChannel && refundChannel.key === REFOUND_CHANNEL_TYPE.creditCard && data.partial && (
                    <div className={classNames("formControl")}>
                        {!cardTerminalRefund && (
                          <div className={classNames("title")}>{t("admin-orders.REFUND_ORDER_MAX_AMOUNT_LABEL")} {maxAmount}</div>
                        )}
                        {minAmount >= maxAmount && !cardTerminalRefund && (<span className={classNames("error")}>{t("admin-orders.CANT_DO_REFUND")}</span>)}
                        <input className={classNames({disabled: cardTerminalRefund ? isDisabled() : (isDisabled() || minAmount >= maxAmount)})} type="number"
                               value={data.amount} step="0.1" onChange={handleOnAmountChange} />
                    </div>
                )}
                {refundChannel && refundChannel.key === REFOUND_CHANNEL_TYPE.loyalty && (
                    <div className={classNames("formControl")}>
                        <div className={classNames("title")}>{t("admin-orders.REFUND_ORDER_AMOUNT_LABEL")}</div>
                        <input type="number" value={data.amount} step="0.1" onChange={handleOnAmountChange} />
                    </div>
                )}
                <div className={classNames("formControl")}>
                    <div className={classNames("title")}>{t("admin-orders.REFUND_ORDER_NOTE_LABEL")}</div>
                    <textarea className={classNames("inputArea")} rows="5" value={data.notes}
                        onChange={e=> handleOnChange("notes", e.target.value)}
                    ></textarea>
                </div>
            </div>
            <LayoutHeaderControls
                onSave={handleOnSave}
                withConfirmDialog
                disabledSaveButton={isDisabled() ? isDisabled() && data.partial : false}
                onClose={onClose}
            />
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        refundOrder: data=> dispatch(createAction(ADMIN_ORDER_REFUND, data)),
        refundBulkOrder: data=> dispatch(createAction(ADMIN_ORDER_REFUND_BULK, data)),
    };
};

export default  connect(null, mapDispatchToProps)(withTranslation()(RefundOrder));
